import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'sera-button',
    templateUrl: './sera-button.component.html',
    styleUrls: ['./sera-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraButtonComponent {
    constructor() {}

    @Input()
    label!: string;

    @Input()
    type: string = 'button';

    @Input()
    isFormSubmitButton: boolean = false;

    @Input()
    icon!: string;

    @Input()
    iconPos: 'left' | 'right' = 'left';

    @Input()
    loading: boolean = false;

    @Input()
    isDisabled: boolean = false;

    @Input()
    style: {} = {};

    @Input()
    class!: string;

    @Input()
    styleClass!: string;

    @Input()
    tooltip!: string;

    @Output() buttonClick: EventEmitter<any> = new EventEmitter();

    @Output() buttonBlur: EventEmitter<any> = new EventEmitter();

    @Output() buttonFocus: EventEmitter<any> = new EventEmitter();

    emitButtonClick(value: any): void {
        this.buttonClick.emit(value);
    }

    emitButtonBlur(value: any): void {
        this.buttonBlur.emit(value);
    }

    emitButtonFocus(value: any): void {
        this.buttonFocus.emit(value);
    }
}
